module.exports = __webpack_public_path__ + "static/Mueller.2725b899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mueller.jpg
// module id = 465
// module chunks = 213187215133716